<div [class.selected]="isSelected()" class="tab-content">
  <ng-content></ng-content>
</div>
